import { OrganizationsState } from './organizations.model';

export const LAST_ORGANIZATION_STORAGE_ID = 'LAST_ORGANIZATION_ID';

export const organizationsInitState: OrganizationsState = {
  current: null,
  last: null,
  organizationIds: [],
  organizations: null,
  count: 0,
  loading: false,
  error: undefined,
};
